import type { ThemeConfig } from "antd";
import { theme as antdTheme } from "antd";
import type { AppTheme } from "./catalog";
import { isDarkTheme } from "./catalog";
import { THEME_PALETTES } from "./palettes";

/** Readable defaults for data-entry screens (not ultra-compact). */
export function buildThemeConfig(theme: AppTheme): ThemeConfig {
  const palette = THEME_PALETTES[theme];
  const algorithm = isDarkTheme(theme) ? [antdTheme.darkAlgorithm] : [];

  return {
    algorithm,
    token: {
      colorPrimary: palette.primary,
      colorBgBase: palette.bgBase,
      colorBgLayout: palette.bgLayout,
      colorBgContainer: palette.bgContainer,
      colorBgElevated: palette.bgElevated,
      colorText: palette.text,
      colorTextSecondary: palette.textSecondary,
      colorTextTertiary: palette.textSecondary,
      colorBorder: palette.border,
      colorIcon: palette.icon,
      colorIconHover: palette.primary,
      fontSize: 14,
      fontSizeSM: 12,
      fontSizeLG: 16,
      lineHeight: 1.5,
      borderRadius: palette.borderRadius,
      controlHeight: 32,
      paddingContentHorizontal: 12,
    },
    components: {
      Table: {
        cellPaddingBlock: 6,
        cellPaddingInline: 10,
        fontSize: 14,
        headerBg: palette.tableHeaderBg,
        borderColor: palette.border,
      },
      Card: {
        headerFontSize: 15,
      },
      Menu: {
        itemHeight: 36,
        fontSize: 14,
      },
      Form: {
        itemMarginBottom: 14,
        labelFontSize: 14,
        verticalLabelPadding: "0 0 4px",
      },
      Layout: {
        headerHeight: 44,
        siderBg: palette.siderBg,
      },
      Modal: {
        titleFontSize: 16,
      },
    },
  };
}
